export function fullPageSlug(slug?: string): string {
  if (!slug) {
    return `https://${process.env['NEXT_PUBLIC_WEB_URL']}`;
  }
  // Trim trailing slashes from slug before concatenating
  const trimmedSlug = slug.replace(/\/+$/, '');
  return `https://${process.env['NEXT_PUBLIC_WEB_URL']}/${trimmedSlug}`;
}
